// extracted by mini-css-extract-plugin
export default {"container":"signin_container__nITf9","topBox":"signin_topBox__I3tPN","bottomBox":"signin_bottomBox__jNMa0"};